<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
  </div>
</template>

<script>
export default {
  async created() {
    const vm = this
    vm.$vs.loading()
    vm.$store.dispatch('signOut', this)
    setTimeout(() => {
      vm.$vs.loading.close()
    }, 2000)
  }
};
</script>
